/**
 * Navigation Routes Configuration
 * Defines navigation menu items for admin, dashboard, user, and public areas
 */

import { navigationPaths } from './paths.config'

export const navigationRoutes = [
	// Admin - Entities
	{
		id: 2,
		area: 'admin' as const,
		group: 'entities' as const,
		type: 'link' as const,
		translationKey: 'admin.roles.title',
		icon: 'person',
		routeKey: 'admin.roles.base',
		allowedRoles: ['admin'] as const,
		showCreateButton: false,
	},
	{
		id: 1,
		area: 'admin' as const,
		group: 'entities' as const,
		type: 'link' as const,
		translationKey: 'admin.users.title',
		icon: 'person',
		routeKey: 'admin.users.base',
		allowedRoles: ['admin'] as const,
		showCreateButton: true,
		createIntent: 'createUser',
	},
	{
		id: 9,
		area: 'admin' as const,
		group: 'entities' as const,
		type: 'link' as const,
		translationKey: 'admin.categories.title',
		icon: 'file-text',
		routeKey: 'admin.categories.base',
		allowedRoles: ['admin', 'editor'] as const,
		showCreateButton: true,
		createIntent: 'createCategory',
	},
	{
		id: 5,
		area: 'admin' as const,
		group: 'entities' as const,
		type: 'link' as const,
		translationKey: 'admin.courses.title',
		icon: 'activity-log',
		routeKey: 'admin.courses.base',
		allowedRoles: ['admin', 'editor'] as const,
		showCreateButton: true,
		createIntent: 'createCourse',
	},
	{
		id: 52,
		area: 'admin' as const,
		group: 'entities' as const,
		type: 'link' as const,
		translationKey: 'admin.courses.creation.list.title',
		icon: 'activity-log',
		routeKey: 'admin.courses.creation.list',
		allowedRoles: ['admin'] as const,
		showCreateButton: false,
	},

	// Admin - Studios
	{
		id: 12,
		area: 'admin' as const,
		group: 'studios' as const,
		type: 'link' as const,
		translationKey: 'navigation.sidebarAdmin.insights',
		icon: 'activity-log',
		href: '/admin/insights',
		allowedRoles: ['admin'] as const,
		showCreateButton: false,
	},
	{
		id: 3,
		area: 'admin' as const,
		group: 'studios' as const,
		type: 'link' as const,
		translationKey: 'navigation.sidebarAdmin.configStudio',
		icon: 'dashboard',
		routeKey: 'admin.configStudio.base',
		allowedRoles: ['admin'] as const,
		featureFlag: 'admin.preferences.features.configStudio',
		showCreateButton: false,
	},
	{
		id: 8,
		area: 'admin' as const,
		group: 'studios' as const,
		type: 'link' as const,
		translationKey: 'navigation.sidebarAdmin.emailStudio',
		icon: 'envelope-closed',
		routeKey: 'admin.emailStudio.base',
		allowedRoles: ['admin'] as const,
		featureFlag: 'admin.preferences.features.emailStudio',
		showCreateButton: false,
	},
	{
		id: 11,
		area: 'admin' as const,
		group: 'studios' as const,
		type: 'link' as const,
		translationKey: 'navigation.sidebarAdmin.emailSequences',
		icon: 'envelope-closed',
		href: '/admin/email-sequences',
		allowedRoles: ['admin'] as const,
		showCreateButton: false,
	},

	// Admin - Support/Documentation
	{
		id: 10,
		area: 'admin' as const,
		group: 'support' as const,
		type: 'link' as const,
		translationKey: 'navigation.sidebarAdmin.documentation',
		icon: 'file-text',
		href: navigationPaths.internalDocs.base.path,
		routeKey: 'internalDocs.base',
		target: '_blank',
		allowedRoles: ['admin', 'editor'] as const,
		showCreateButton: false,
	},

	// Dashboard - Entities
	{
		id: 98,
		area: 'dashboard' as const,
		group: 'entities' as const,
		type: 'link' as const,
		translationKey: 'navigation.sidebar.studyPanel',
		icon: 'dashboard',
		href: '/learn/dashboard',
		requiresAuth: true,
		showCreateButton: false,
	},
	{
		id: 99,
		area: 'dashboard' as const,
		group: 'entities' as const,
		type: 'link' as const,
		translationKey: 'navigation.sidebar.personalTrail',
		icon: 'activity-log',
		href: '/learn/trail',
		requiresAuth: true,
		showCreateButton: false,
	},
	{
		id: 103,
		area: 'dashboard' as const,
		group: 'entities' as const,
		type: 'link' as const,
		translationKey: 'dashboard.topics.title',
		icon: 'disc',
		routeKey: 'topics.base',
		entityType: 'topic',
		showCreateButton: false,
	},
	{
		id: 102,
		area: 'dashboard' as const,
		group: 'entities' as const,
		type: 'dialog' as const,
		translationKey: 'navigation.sidebar.search',
		icon: 'magnifying-glass',
		component: 'SearchPublicCoursesDialog',
		showCreateButton: false,
	},

	// Dashboard - Support
	{
		id: 210,
		area: 'dashboard' as const,
		group: 'support' as const,
		type: 'link' as const,
		translationKey: 'navigation.sidebar.support.title',
		icon: 'question-mark-circled',
		href: '#',
	},

	// Dashboard - User
	{
		id: 211,
		area: 'dashboard' as const,
		group: 'user' as const,
		type: 'link' as const,
		translationKey: 'navigation.sidebar.user',
		icon: 'avatar',
		href: '#',
	},

	// User - Entities
	{
		id: 202,
		area: 'user' as const,
		group: 'entities' as const,
		type: 'link' as const,
		translationKey: 'navigation.sidebar.topics',
		icon: 'radiobutton',
		routeKey: 'topics.base',
		requiresAuth: true,
	},
	{
		id: 203,
		area: 'user' as const,
		group: 'entities' as const,
		type: 'link' as const,
		translationKey: 'navigation.sidebar.templates',
		icon: 'file-text',
		routeKey: 'templates.base',
		requiresAuth: true,
	},

	// User - Support
	{
		id: 215,
		area: 'user' as const,
		group: 'support' as const,
		type: 'link' as const,
		translationKey: 'navigation.sidebar.support.contactUs',
		icon: 'envelope-closed',
		href: '/contact',
	},
	{
		id: 216,
		area: 'user' as const,
		group: 'support' as const,
		type: 'link' as const,
		translationKey: 'navigation.sidebar.support.documentation',
		icon: 'file-text',
		href: navigationPaths.docs.base.path,
		enabled: false,
	},
	{
		id: 212,
		area: 'user' as const,
		group: 'support' as const,
		type: 'dialog' as const,
		translationKey: 'navigation.sidebar.support.reportBug.title',
		icon: 'bell',
		component: 'ReportBugDialog',
	},

	// User - User
	{
		id: 213,
		area: 'user' as const,
		group: 'user' as const,
		type: 'link' as const,
		translationKey: 'navigation.sidebar.studyPanel',
		icon: 'dashboard',
		routeKey: 'studyPanel.base',
		requiresAuth: true,
	},
	{
		id: 218,
		area: 'user' as const,
		group: 'user' as const,
		type: 'view' as const,
		translationKey: 'navigation.sidebar.theme.toggle',
		icon: 'moon',
		component: 'ThemeToggle',
		allowedRoles: ['admin'] as const,
		requiresAuth: true,
	},
	{
		id: 214,
		area: 'user' as const,
		group: 'user' as const,
		type: 'link' as const,
		translationKey: 'navigation.sidebar.settings',
		icon: 'avatar',
		routeKey: 'settings.billing',
		requiresAuth: true,
	},
	{
		id: 217,
		area: 'user' as const,
		group: 'user' as const,
		type: 'link' as const,
		translationKey: 'navigation.sidebar.logout.title',
		icon: 'exit',
		href: '/logout',
	},

	// Public - Marketing
	{
		id: 301,
		area: 'public' as const,
		group: 'marketing' as const,
		type: 'link' as const,
		translationKey: 'marketing.courses',
		icon: 'activity-log',
		href: '/courses',
	},
	{
		id: 303,
		area: 'public' as const,
		group: 'marketing' as const,
		type: 'link' as const,
		translationKey: 'marketing.nav.blog',
		icon: 'file-text',
		href: '/blog',
		enabled: false,
	},
	{
		id: 304,
		area: 'public' as const,
		group: 'marketing' as const,
		type: 'link' as const,
		translationKey: 'marketing.nav.about',
		icon: 'person',
		href: '/about',
		enabled: false,
	},

	// Public - Support
	{
		id: 306,
		area: 'public' as const,
		group: 'support' as const,
		type: 'link' as const,
		translationKey: 'marketing.nav.legal',
		icon: 'scales',
		href: '/legal',
	},
	{
		id: 307,
		area: 'public' as const,
		group: 'support' as const,
		type: 'link' as const,
		translationKey: 'marketing.nav.help',
		icon: 'question-mark-circled',
		href: navigationPaths.docs.base.path,
	},

	// Public - Tools
	{
		id: 311,
		area: 'public' as const,
		group: 'tools' as const,
		type: 'link' as const,
		translationKey: 'marketing.nav.signIn',
		icon: 'person',
		href: '/login',
	},
	{
		id: 312,
		area: 'public' as const,
		group: 'tools' as const,
		type: 'link' as const,
		translationKey: 'marketing.nav.getStarted',
		icon: 'star',
		href: '/signup',
		featureFlag: 'auth.signup.enabled',
	},
] as const

export type NavigationRoutes = typeof navigationRoutes
export type NavigationRoute = (typeof navigationRoutes)[number]
